import { Ban } from 'lucide-react';

/**
 * Red/amber banner shown when the entered cost matches an existing entry.
 * The user must tick the override checkbox to submit anyway.
 */
export const DuplicateWarningBanner = ({ duplicateCheck, duplicateOverride, setDuplicateOverride }) => {
  if (!duplicateCheck.is_duplicate) return null;
  const bg = duplicateOverride ? 'bg-amber-50 border-amber-300' : 'bg-red-50 border-red-300';
  const iconColor = duplicateOverride ? 'text-amber-600' : 'text-red-600';
  const headerColor = duplicateOverride ? 'text-amber-800' : 'text-red-800';
  const chipStyle = duplicateOverride ? 'text-amber-700 bg-amber-100' : 'text-red-700 bg-red-100';
  const labelColor = duplicateOverride ? 'text-amber-800' : 'text-red-700';

  return (
    <div className={`flex items-start gap-3 p-3 rounded-lg border ${bg}`} data-testid="duplicate-warning-banner">
      <Ban className={`w-5 h-5 mt-0.5 shrink-0 ${iconColor}`} />
      <div className="space-y-1 flex-1">
        <p className={`text-sm font-semibold ${headerColor}`}>
          {duplicateOverride ? 'Duplicate override accepted' : 'Duplicate entry detected'}
        </p>
        {duplicateCheck.duplicates.map((dup, i) => (
          <div key={dup.id || i} className={`text-xs rounded px-2 py-1 ${chipStyle}`}>
            {dup.cost_type?.toUpperCase()} | {dup.date} | R {Number(dup.amount).toLocaleString('en-ZA', { minimumFractionDigits: 2 })}
            {dup.invoice_number ? ` | Invoice: ${dup.invoice_number}` : ''}
            {dup.vehicle_name ? ` | ${dup.vehicle_name}` : ''}
          </div>
        ))}
        <label className="flex items-center gap-2 pt-1 cursor-pointer" data-testid="duplicate-override-label">
          <input
            type="checkbox"
            checked={duplicateOverride}
            onChange={(e) => setDuplicateOverride(e.target.checked)}
            className="w-4 h-4 rounded border-gray-300 accent-amber-600"
            data-testid="duplicate-override-checkbox"
          />
          <span className={`text-xs font-medium ${labelColor}`}>
            I confirm this is not a duplicate — override and add anyway
          </span>
        </label>
      </div>
    </div>
  );
};
